module.exports = __webpack_public_path__ + "img/27174661000190.56e11548.png";